import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Empty, Badge, Affix, Button, Select, Spin } from "antd";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router";
import { Loading, Report } from "notiflix";
import moment from "moment";

import ImportantInfo from "../../../atoms/important-updates";
import Navbar from "../../../atoms/navbar";
import Footer from "../../../atoms/footer";
import "./styles.css";

import { loginRequest } from "../../../config/api.config";
import { requestToken } from "../../../auth/AuthServices";

import { InitializeTicket } from "../../../redux/action";
import HeaderFarms from "../../../utils/header_farms";
import { PlusOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import API from "../../../services";

const STATUS_OPTIONS = [
    { label: "Waiting", value: "Waiting Approval" },
    { label: "Approved", value: "Approved" },
    { label: "Reject", value: "Reject" },
    { label: "Closed", value: "Closed" },
    { label: "Cancel", value: "Cancel" },
];

const STATUS_CONFIG = {
    "Waiting Approval": { color: "#FF9900" },
    Approved: { color: "blue" },
    Reject: { color: "red" },
    Cancel: { color: "green" },
    Closed: { color: "green" },
};

function DSTHistory() {
    const navigate = useNavigate();
    const { Option } = Select;

    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const [loading, setLoading] = useState(true);
    const [historyDastr, setHistoryDastr] = useState([]);
    const [filter, setFilter] = useState("Waiting Approval");

    const filteredHistory = useMemo(() => {
        if (!historyDastr || historyDastr.length === 0) return [];
        return historyDastr.filter((item) => {
            const status = item?.approval?.status;
            if (!status) return false;
            return status === filter;
        });
    }, [historyDastr, filter]);

    function handleLogin(msalInstance) {
        msalInstance
            .loginRedirect(loginRequest)
            .catch((error) => console.error(error));
    }

    async function getAllHistory(accessToken) {
        try {
            const response = await API.getDocumentsByEmployeeId(
                HeaderFarms(accessToken)
            );
            setHistoryDastr(response.data || []);
        } catch (error) {
            console.error("getAllHistory", error);
            Report.warning(
                "DASTR",
                "Maaf, terjadi masalah saat memuat data",
                "Mengerti"
            );
        } finally {
            Loading.remove();
            setLoading(false);
        }
    }

    function goDetail(recordId) {
        if (!recordId) return;
        navigate(`/dst/view/${recordId}`);
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!isAuthenticated) return;
            try {
                const accessToken = await requestToken();
                if (!accessToken) {
                    handleLogin(instance);
                    navigate("/");
                    return;
                }
                await getAllHistory(accessToken);
            } catch (error) {
                console.error("Error fetching DASTR history:", error);
                handleLogin(instance);
                navigate("/");
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);

    return (
        <Fragment>
            <Navbar
                title="History"
                back={true}
                subtitle="DASTR"
                navigate="/home"
            ></Navbar>
            <div className="container white-back-cr" style={{ minHeight: 500 }}>
                <ImportantInfo></ImportantInfo>
                <div className="container mt-3 p-3">
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <Affix offsetTop={10}>
                                <div className="col-md-6 d-flex justify-content-start">
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={() => navigate("/dst/create")}
                                        size="middle"
                                    >
                                        New Document
                                    </Button>
                                </div>
                            </Affix>
                        </div>
                    </div>
                    <div className="row mb-5">
                        <div className="col"></div>
                        <div className="col-md-6 d-flex justify-content-end">
                            <label style={{ marginRight: 10, marginTop: 5 }}>Filter</label>
                            <Select
                                value={filter}
                                onChange={setFilter}
                            >
                                {STATUS_OPTIONS.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            {filteredHistory.length > 0 ? (
                                filteredHistory.map((data) => {
                                    const status = data?.approval?.status;
                                    const badgeConfig = status ? STATUS_CONFIG[status] : null;

                                    return (
                                        <Fragment key={data.record_id}>
                                            <Badge.Ribbon
                                                color={badgeConfig?.color || "default"}
                                                text={status || "-"}
                                            >
                                                <div
                                                    className="list-style p-3 px-4 mb-3"
                                                    onClick={() => goDetail(data.record_id)}
                                                >
                                                    <div className="content">
                                                        <p
                                                            style={{
                                                                fontSize: 10,
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 1,
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                            }}
                                                            className="mb-1"
                                                        >
                                                            {data.description || "-"}
                                                        </p>
                                                        <p
                                                            className="mb-0"
                                                            style={{ fontSize: 10, color: "#9aa0a6" }}
                                                        >
                                                            {data.record_id}
                                                        </p>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <p
                                                            style={{ color: "#B7B7B7", fontSize: 11 }}
                                                        >
                                                            {moment(data.created_at).format("LLL")}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Badge.Ribbon>
                                        </Fragment>
                                    );
                                })
                            ) : (
                                !loading && <Empty className="mt-5" />
                            )}

                            {loading && (
                                <div
                                    className="fs-6 text-center mt-5"
                                    style={{ color: "#B7B7B7" }}
                                >
                                    <Spin size="large" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </Fragment>
    );
}

const reduxState = (state) => ({
    initializeTicket: state.initializeTicket,
});

const reduxDispatch = (dispatch) => ({
    setInitializeTicket: (navigate, data) =>
        dispatch(InitializeTicket(navigate, data)),
});

export default connect(reduxState, reduxDispatch)(DSTHistory);


